<template>
  <div class="sale-import-modal">
    <div class="modal-card">
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      <header class="modal-card-head">
        <p class="modal-card-title">Importar Vendas</p>
      </header>
      <section class="modal-card-body">
        <b-notification type="is-secondary">
          A importação segue algumas regras de formatação para a tabela a ser
          importada.
          <a :href="modelUrl" target="_blank">Baixe o modelo.</a>
        </b-notification>

        <app-autocomplete
          label="Rede"
          field="name"
          :searchFunction="searchNetworkFn"
          :resourceIdFunction="resourceNetworkFn"
          v-model="networkId"
          required
        ></app-autocomplete>

        <app-file-picker
          @fileSelected="onFileSelect"
          @fileDeleted="onFileDelete"
          label="Arquivo .xlsx"
          accept=".xlsx, .xls"
        ></app-file-picker>

        <ul v-if="errors.length" class="errors-container">
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>

        <button
          @click="uploadFile()"
          :disabled="!file || !networkId"
          type="button"
          class="mt-4"
          v-app-button
        >
          Importar
        </button>
      </section>
      <footer class="modal-card-foot">
        <button type="button" v-app-button.clear @click="$parent.close()">
          Fechar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import NetworkService from '@/services/network.service';
import SaleService from '@/services/sale.service';
import { URLS } from '@/constants/url.constants';

import flattenDeep from 'lodash/flattenDeep';

export default {
  name: 'sale-import-modal',
  data: () => {
    return {
      file: null,
      networkId: null,
      isLoading: false,
      errors: [],
      modelUrl: URLS.IMPORT_SALES_MODEL,
    };
  },
  methods: {
    onFileSelect(file) {
      this.file = file;
    },
    onFileDelete() {
      this.file = null;
    },
    uploadFile() {
      this.isLoading = true;
      this.errors = [];

      SaleService.import(this.networkId, this.file)
        .then(() => {
          this.toastify(`Importação iniciada com sucesso.`);
          this.$parent.close();
          this.$emit('success', true);
        })
        .catch(({ response }) => {
          const { status, data } = response;

          if (status === 422) this.errors = flattenDeep(data);
          else
            this.toastify(
              response.data.message || 'Erro ao iniciar importação.',
              'error'
            );
        })
        .finally(() => (this.isLoading = false));
    },
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
  },
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  align-content: center;
  justify-content: flex-end;
}

.errors-container {
  margin: 16px 0;
  padding: 5px;
  max-height: 150px;
  overflow-y: scroll;
}
</style>
